export default [
  require("/home/runner/work/kritzel/kritzel/apps/website/.docusaurus/docusaurus-plugin-css-cascade-layers/default/layers.css"),
  require("/home/runner/work/kritzel/kritzel/node_modules/infima/dist/css/default/default.css"),
  require("/home/runner/work/kritzel/kritzel/node_modules/@docusaurus/theme-classic/lib/prism-include-languages"),
  require("/home/runner/work/kritzel/kritzel/node_modules/@docusaurus/theme-classic/lib/nprogress"),
  require("/home/runner/work/kritzel/kritzel/apps/website/src/css/theming.css"),
  require("/home/runner/work/kritzel/kritzel/apps/website/src/css/typography.css"),
  require("/home/runner/work/kritzel/kritzel/apps/website/src/css/header.css"),
  require("/home/runner/work/kritzel/kritzel/apps/website/src/css/navbar.css"),
  require("/home/runner/work/kritzel/kritzel/apps/website/src/css/hero.css"),
  require("/home/runner/work/kritzel/kritzel/apps/website/src/css/buttons.css"),
  require("/home/runner/work/kritzel/kritzel/apps/website/src/css/general.css"),
  require("/home/runner/work/kritzel/kritzel/apps/website/src/css/footer.css"),
  require("/home/runner/work/kritzel/kritzel/apps/website/src/clientModules/pageTransition.ts"),
];
